import axios, { AxiosRequestConfig } from 'axios';

const config: AxiosRequestConfig = {
  baseURL: 'https://www.epicteller.com/api/',
};

const predictAPI = axios.create(config);

export default predictAPI;
